//#region src/verticals/host/HostEvent.ts
var e = /* @__PURE__ */ function(e) {
	return e.ListingCreated = "host.listing.created", e.ListingPublished = "host.listing.published", e.ListingUnpublished = "host.listing.unpublished", e.AvailabilityUpdated = "host.availability.updated", e.BookingAccepted = "host.booking.accepted", e.BookingDeclined = "host.booking.declined", e.DashboardViewed = "host.page.dashboard_viewed", e;
}({});
//#endregion
export { e as HostEvent };
